export function findSameValueProps(items: object[], ...keys): object {
    const commonValues = {};
    keys.forEach(k => commonValues[k] = items[0][k]);

    for (const item of items.slice(1)) {
        for (const key of keys) {
            if (commonValues[key] !== item[key]) {
                commonValues[key] = 'multiple values';
                delete keys[key];
            }
        }
    }

    return commonValues;
}

export function uniqueValuesForKey<T extends object> (objects: T[], key: keyof T, sort = true) {
    const setObj: any = {};
    const values = objects.forEach(obj => {
        const val = obj[key] ? obj[key] : '';
        setObj[val] = true;
    });

    let set = Object.keys(setObj);

    if (sort) {
        set = set.sort();
    }

    return set;
}

function deepCopy(obj: object): object {
    return JSON.parse(JSON.stringify(obj));
}

export const ObjectUtils = {
    findSameValueProps,
    uniqueValuesForKey,
    deepCopy
};
